import { createFileRoute, stripSearchParams } from '@tanstack/react-router'
import { z } from 'zod'
import { OffersPage } from '@/components/offers/offers-page'

export const statusFilterValues = [
  'all',
  'open',
  'accepted',
  'cancelled',
] as const
export const expiredFilterValues = ['all', 'expired', 'active'] as const

const defaultValues = {
  page: 0,
  status: 'all' as const,
  expired: 'all' as const,
}

export const offersSearchSchema = z.object({
  page: z
    .number()
    .int()
    .min(0)
    .default(defaultValues.page)
    .catch(defaultValues.page),
  cursor: z.string().nullable().optional(),
  q: z.string().optional(),
  history: z.string().optional(),
  status: z
    .enum(statusFilterValues)
    .default(defaultValues.status)
    .catch(defaultValues.status),
  expired: z
    .enum(expiredFilterValues)
    .default(defaultValues.expired)
    .catch(defaultValues.expired),
})

export const Route = createFileRoute('/_auth/_main-layout/offers')({
  component: OffersPage,
  validateSearch: offersSearchSchema,
  search: {
    middlewares: [stripSearchParams(defaultValues)],
  },
})
